let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("aTvLE"), load("c6MKV"), load("5doAZ")]).then(() => parcelRequire('h8ksv'));